"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
exports.Col = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  ${props => (props.noHorizontalPaddings || props.fullWidthLayout) && 'padding-left: 0px; padding-right: 0px;'}
  ${props => props.noPaddings && `padding: 0;`}
  ${props => !props.fullWidthLayout &&
    props.imageWithTextOverlayBlock &&
    props.columns === 6 &&
    `@media (min-width: ${props.theme.breakpoints.md}px) {
      &:nth-child(odd) {
        padding-right: 0;
        }
        &:nth-child(even) {
          padding-left: 0;
        }
    }
    `}

  ${props => !props.fullWidthLayout &&
    props.imageWithTextOverlayBlock &&
    props.columns === 4 &&
    `
    @media (min-width: ${props.theme.breakpoints.lg}px) {
      &:nth-child(1) {
        padding-right: 0;
        }
        &:nth-child(2) {
          padding: 0;
        }
        &:nth-child(3) {
          padding-left: 0;
        }
    }
    @media (min-width: ${props.theme.breakpoints.md}px) and (max-width: ${props.theme.breakpoints.lg}px) {
      &:nth-child(odd) {
        padding-right: 0;
        }
        &:nth-child(even) {
          padding-left: 0;
        }
    }
    
    `}

  ${props => !props.fullWidthLayout &&
    props.imageWithTextOverlayBlock &&
    props.columns === 3 &&
    `
    @media (min-width: ${props.theme.breakpoints.lg}px) {
      &:nth-child(1) {
        padding-right: 0;
        }
        &:nth-child(2) {
          padding: 0;
        }
        &:nth-child(3) {
          padding: 0;
        }
        &:nth-child(4) {
          padding-left: 0;
        }
    }
    @media (min-width: ${props.theme.breakpoints.md}px) and (max-width: ${props.theme.breakpoints.lg}px) {
      &:nth-child(odd) {
        padding-right: 0;
        }
        &:nth-child(even) {
          padding-left: 0;
        }
    }`}
`;
exports.default = {
    Col: exports.Col
};
